import { render, staticRenderFns } from "./ReferralCodeDialog.vue?vue&type=template&id=58606be4&scoped=true&"
import script from "./ReferralCodeDialog.vue?vue&type=script&lang=js&"
export * from "./ReferralCodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCodeDialog.vue?vue&type=style&index=0&id=58606be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58606be4",
  null
  
)

export default component.exports